<!-- Stepper -->
<div class="flex justify-center bg-gray-100 lg:p-4">
  <ul class="relative flex flex-row lg:w-1/2">
    <!-- Item -->
    <li class="flex items-center gap-x-2 shrink basis-0 flex-1 group">
      <div
        class="min-w-7 min-h-7 inline-flex justify-center items-center text-xs align-middle"
      >
        <span
          class="size-7 flex justify-center items-center flex-shrink-0 bg-gray-800 font-medium text-white rounded-full dark:bg-white dark:text-neutral-800"
          [ngClass]="{
            'text-purple':
              isSelect === 'cart' ||
              isSelect === 'payment' ||
              isSelect === 'order'
          }"
        >
          1
        </span>
        <span
          class="ms-2 block text-sm font-medium text-gray-800 dark:text-black"
          [ngClass]="{
            'text-purple1':
              isSelect === 'cart' ||
              isSelect === 'payment' ||
              isSelect === 'order'
          }"
        >
          Cart
        </span>
      </div>
      <div
        class="w-full h-px flex-1 bg-gray-800 group-last:hidden dark:bg-neutral-700"
        [ngClass]="{
          'text-purple':
            isSelect === 'cart' ||
            isSelect === 'payment' ||
            isSelect === 'order'
        }"
      ></div>
    </li>
    <!-- End Item -->

    <!-- Item -->
    <li class="flex items-center gap-x-2 shrink basis-0 flex-1 group">
      <div
        class="min-w-7 min-h-7 inline-flex justify-center items-center text-xs align-middle"
      >
        <span
          class="size-7 flex justify-center items-center flex-shrink-0 bg-gray-800 font-medium text-white rounded-full dark:bg-white dark:text-neutral-800"
          [ngClass]="{
            'text-purple': isSelect === 'payment' || isSelect === 'order'
          }"
        >
          2
        </span>
        <span
          class="ms-2 block text-sm font-medium text-gray-800 dark:text-black"
          [ngClass]="{
            'text-purple1': isSelect === 'payment' || isSelect === 'order'
          }"
        >
          Payment
        </span>
      </div>
      <div
        class="w-full h-px flex-1 bg-gray-800 group-last:hidden dark:bg-neutral-700"
        [ngClass]="{
          'text-purple': isSelect === 'payment' || isSelect === 'order'
        }"
      ></div>
    </li>
    <!-- End Item -->

    <!-- Item -->
    <li class="flex items-center gap-x-2 shrink basis-0 flex-1 group">
      <div
        class="min-w-7 min-h-7 inline-flex justify-center items-center text-xs align-middle"
      >
        <span
          class="size-7 flex justify-center items-center flex-shrink-0 bg-gray-800 font-medium text-white rounded-full dark:bg-white dark:text-neutral-800"
          [ngClass]="{ 'text-purple': isSelect === 'order' }"
        >
          3
        </span>
        <span
          class="ms-2 block text-sm font-medium text-gray-800 dark:text-black"
          [ngClass]="{ 'text-purple1': isSelect === 'order' }"
        >
          Complete
        </span>
      </div>
      <div
        class="w-full h-px flex-1 bg-gray-800 group-last:hidden dark:bg-neutral-700"
        [ngClass]="{ 'text-purple1': isSelect === 'order' }"
      ></div>
    </li>
    <!-- End Item -->
  </ul>
</div>
<!-- End Stepper -->

<!-- delivery address here -->
<div class="container mx-auto px-4" *ngIf="isSelect === 'cart'">
  <div class="flex justify-between">
  <h1 class="text-2xl font-semibold mb-4">My Cart</h1>

          </div>
  <div *ngIf="totalProducts > 0">
    <div class="relative mb-4 w-full" *ngFor="let address of addressDetails">
      <!-- <span class="absolute right-4 top-1/2 box-content block h-3 w-3 -translate-y-1/2 "></span>  -->
      <label
        class="flex cursor-pointer flex-col rounded-2xl border border-purple-700 bg-white p-4 pr-8 sm:pr-16"
        *ngIf="address?.isDefault === true"
      >
        <div class="lg:flex justify-between overflow-hidden">
          <span class="text-xl font-semibold">
            <p>{{ address?.addressType }}</p>
            <b>{{ address?.delivery_name }} </b> ({{
              address?.delivery_mobile
            }}) <br />
            <p class="text-lg text-purple-700">
              {{ address?.delivery_address }},{{ address?.delivery_city }},{{
                address?.delivery_pincode
              }},{{ address?.delivery_state }},{{ address?.delivery_country }}
            </p>
          </span>
          <button
            class="btncolor lg:m-4 w-auto dark:bg-gray-600 text-white py-2 px-8 rounded-lg font-bold hover:bg-gray-800 dark:hover:bg-gray-700 shadow-lg"
            (click)="openDialog()"
          >
            Change Address
          </button>
        </div>
      </label>
      
    </div>
    
  </div>
</div>
<!---->

<!--my Cart Start Here -->
<div class="flex flex-col md:flex-row" *ngIf="isSelect === 'cart'">
  <div class="w-full lg:m-4 p-5">
    <div class="" *ngIf="totalProducts >= 1">
      <app-my-cart
        *ngFor="let product of cartData"
        (buttonClicked)="onSourceButtonClick($event)"
        (cartClick)="updateCart()"
        [product]="product"
        (colorSelected)="receiveColor($event)"
      ></app-my-cart>
    </div>
    <div class="m-auto text-center" *ngIf="totalProducts === 0">
      <div
        class="no-file-found flex flex-col items-center justify-center py-8 px-4 text-center bg-white dark:bg-white rounded-lg"
      >
        <!-- <svg viewBox="0 -1 22 22"class="w-28 h-28 dark:text-gray-400 text-gray-700"  version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" stroke=""><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>bag_minus [#1121]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-380.000000, -3159.000000)" fill="#000000"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M346.000448,3018 C346.000448,3018.552 345.552448,3019 345.000448,3019 L341.000448,3019 C340.448448,3019 340.000448,3018.552 340.000448,3018 C340.000448,3017.448 340.448448,3017 341.000448,3017 L345.000448,3017 C345.552448,3017 346.000448,3017.448 346.000448,3018 L346.000448,3018 Z M337.000448,3005 L331.000448,3005 L331.000448,3004 C331.000448,3002.346 332.346448,3001 334.000448,3001 C335.654448,3001 337.000448,3002 337.000448,3004 L337.000448,3005 Z M340.694448,3007.859 L341.714448,3015 L343.734448,3015 L342.551448,3006.717 C342.410448,3005.732 341.566448,3005 340.571448,3005 L339.000448,3005 L339.000448,3004 C339.000448,3001 336.757448,2999 334.000448,2999 C331.243448,2999 329.000448,3001.243 329.000448,3004 L329.000448,3005 L327.735448,3005 C326.739448,3005 325.590448,3005.732 325.449448,3006.717 L324.020448,3016.717 C323.848448,3017.922 324.783448,3019 326.000448,3019 L338.000448,3019 L338.000448,3017 L327.153448,3017 C326.545448,3017 326.077448,3016.461 326.163448,3015.859 L327.306448,3007.859 C327.377448,3007.366 327.799448,3007 328.296448,3007 L329.000448,3007 L329.000448,3009 C329.000448,3009.552 329.448448,3010 330.000448,3010 C330.552448,3010 331.000448,3009.552 331.000448,3009 L331.000448,3007 L337.000448,3007 L337.000448,3009 C337.000448,3009.552 337.448448,3010 338.000448,3010 C338.552448,3010 339.000448,3009.552 339.000448,3009 L339.000448,3007 L339.704448,3007 C340.201448,3007 340.623448,3007.366 340.694448,3007.859 L340.694448,3007.859 Z" id="bag_minus-[#1121]"> </path> </g> </g> </g> </g></svg> -->
        <svg
          viewBox="0 -1 22 22"
          class="w-28 h-28 dark:text-gray-400 text-gray-700"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          fill="#6f6d6d"
          stroke="#6f6d6d"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title>bag_minus [#413e3e]</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="Dribbble-Light-Preview"
                transform="translate(-380.000000, -3159.000000)"
                fill="#837c7c"
              >
                <g id="icons" transform="translate(56.000000, 160.000000)">
                  <path
                    d="M346.000448,3018 C346.000448,3018.552 345.552448,3019 345.000448,3019 L341.000448,3019 C340.448448,3019 340.000448,3018.552 340.000448,3018 C340.000448,3017.448 340.448448,3017 341.000448,3017 L345.000448,3017 C345.552448,3017 346.000448,3017.448 346.000448,3018 L346.000448,3018 Z M337.000448,3005 L331.000448,3005 L331.000448,3004 C331.000448,3002.346 332.346448,3001 334.000448,3001 C335.654448,3001 337.000448,3002 337.000448,3004 L337.000448,3005 Z M340.694448,3007.859 L341.714448,3015 L343.734448,3015 L342.551448,3006.717 C342.410448,3005.732 341.566448,3005 340.571448,3005 L339.000448,3005 L339.000448,3004 C339.000448,3001 336.757448,2999 334.000448,2999 C331.243448,2999 329.000448,3001.243 329.000448,3004 L329.000448,3005 L327.735448,3005 C326.739448,3005 325.590448,3005.732 325.449448,3006.717 L324.020448,3016.717 C323.848448,3017.922 324.783448,3019 326.000448,3019 L338.000448,3019 L338.000448,3017 L327.153448,3017 C326.545448,3017 326.077448,3016.461 326.163448,3015.859 L327.306448,3007.859 C327.377448,3007.366 327.799448,3007 328.296448,3007 L329.000448,3007 L329.000448,3009 C329.000448,3009.552 329.448448,3010 330.000448,3010 C330.552448,3010 331.000448,3009.552 331.000448,3009 L331.000448,3007 L337.000448,3007 L337.000448,3009 C337.000448,3009.552 337.448448,3010 338.000448,3010 C338.552448,3010 339.000448,3009.552 339.000448,3009 L339.000448,3007 L339.704448,3007 C340.201448,3007 340.623448,3007.366 340.694448,3007.859 L340.694448,3007.859 Z"
                    id="bag_minus-[#413e3e]"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <!-- <svg  stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><g id="File_Off"><g><path d="M4,3.308a.5.5,0,0,0-.7.71l.76.76v14.67a2.5,2.5,0,0,0,2.5,2.5H17.44a2.476,2.476,0,0,0,2.28-1.51l.28.28c.45.45,1.16-.26.7-.71Zm14.92,16.33a1.492,1.492,0,0,1-1.48,1.31H6.56a1.5,1.5,0,0,1-1.5-1.5V5.778Z"></path><path d="M13.38,3.088v2.92a2.5,2.5,0,0,0,2.5,2.5h3.07l-.01,6.7a.5.5,0,0,0,1,0V8.538a2.057,2.057,0,0,0-.75-1.47c-1.3-1.26-2.59-2.53-3.89-3.8a3.924,3.924,0,0,0-1.41-1.13,6.523,6.523,0,0,0-1.71-.06H6.81a.5.5,0,0,0,0,1Zm4.83,4.42H15.88a1.5,1.5,0,0,1-1.5-1.5V3.768Z"></path></g></g></svg> -->
        <h3 class="text-xl font-medium mt-4 text-gray-700 dark:text-gray-700 ">
          Your Cart is empty!
        </h3>
        <p class="text-xs font-medium mt-1 text-purple-700 dark:text-gray-700">
          add item now
        </p>
      </div>
    </div>
  </div>
  <div class="md:w-1/4 p-3 m-3" *ngIf="totalProducts > 0">
    <div class="bg-gray-100 p-6 rounded-lg shadow-lg">
      <h1 class="text-xl font-semibold mb-4">Apply Coupon Code</h1>

      <!-- Coupon Code Input -->
      <div class="mb-4">
        <label for="coupon" class="block text-gray-700 font-semibold mb-2"
          >Coupon Code:</label
        >
        <input
          type="text"
          id="coupon"
          name="coupon"
          [(ngModel)]="couponCode"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring focus:purple-blue-500 focus:border-purple-500 uppercase"
          placeholder="Enter coupon code"
        />
      </div>

      <!-- Apply Button -->
      <div class="text-center">
        <button
          class="btncolor text-white px-4 py-2 rounded-lg hover:bg-purple-600 focus:outline-none focus:ring focus:ring-purple-500 focus:bg-purple-50-blue-500"
          (click)="applyCoupon()"
        >
          Apply Coupon
        </button>
      </div>

      <!-- Coupon Code Result -->
      <div
        [ngClass]="{
          'text-purple-500': isCouponApplied,
          'text-red-500': !isCouponApplied
        }"
        class="mt-4 text-sm text-center"
      >
        {{ message }}
      </div>
    </div>

    

    <div class="bg-white rounded-lg shadow-md p-6">
      <h2 class="text-lg font-semibold mb-4">Summary</h2>

      <!-- Display Subtotal Before Coupon -->
      <div class="flex justify-between mb-2">
        <span>Subtotal</span>
        <span>₹ {{ subTotal.toFixed(2) || 0 }}</span>
      </div>

      <!-- Discount or Other Fields Can Be Added Here -->

      <!-- Coupon Field -->
      <div class="flex justify-between mb-2">
        <span>Coupon</span>
        <span>₹ {{ discountPrice?.toFixed(2) || 0 }}</span>
      </div>

      <div class="flex justify-between mb-2">
        <span>Shipping</span>
        <span *ngIf="subTotal.shippingCharge; else freeShipping"
          >₹ {{ subTotal.shippingCharge }}</span
        >
        <ng-template #freeShipping>
          <span style="color: blueviolet">Free</span>
        </ng-template>
      </div>

      <hr class="my-2" />

      <!-- Display Final Total After Coupon -->
      <div class="flex justify-between mb-2">
        <span class="font-semibold">Total</span>
        <!-- Show discounted price if a coupon is applied -->
        <span class="font-semibold" *ngIf="isCouponApplied">
          ₹
          {{
            (
              subTotal -
              discountPrice +
              (cartData?.shipping_charge || 0) -
              (paymentMethod === "online" ? 40 : 0)
            ).toFixed(2)
          }}
        </span>

        <!-- Show normal price if no coupon is applied -->
        <span class="font-semibold" *ngIf="!isCouponApplied">
          ₹
          {{
            (
              subTotal +
              (cartData?.shipping_charge || 0) -
              (paymentMethod === "online" ? 40 : 0)
            ).toFixed(2)
          }}
        </span>
      </div>

      <button
        class="btncolor text-white font-bold text-xl py-2 px-4 rounded-lg mt-4 w-full"
        (click)="onButtonClick()" 
        *ngIf="isSelect === 'cart'"
        
      >
        Checkout
      </button>
    </div>
  </div>
</div>

<!--Mycart End here-->

<app-payment-option
  *ngIf="isSelect === 'payment'"
  (paymentMethodSelected)="onSourceButtonClick($event)"
  (selectPaymentOption)="selectPaymentOption($event)"
  [payments1]="payments1"
 [orderIdCashFree]="orderIdCashFree"
  [totalAmount]="isCouponApplied ?  subTotal- discountPrice : subTotal"
   [isProcessing]="isProcessing" 
   [sessionId]="sessionId"
   [orderId] = "cashFreeOrderId"
   (paymentSuccess)="onPaymentSuccess($event)"  
   (codSelected)="onCodSelected()"
></app-payment-option>


<div
  class="flex flex-col h-screen bg-center bg-cover bg-no-repeat bg-gray-100"
  *ngIf="isSelect === 'order'"
>
  <div
    class="grid place-items-center lg:w-4/5 mx-auto lg:p-10 my-10 sm:my-auto bg-white-600 border-2 border-purple-400 bg-opacity-70 rounded-xl shadow-2xl space-y-5 text-center cursor-pointer"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-36 h-36"
      viewBox="0 0 256 256"
    >
      <path
        fill="#7B68EE"
        d="M208 32H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m-34.34 77.66l-56 56a8 8 0 0 1-11.32 0l-24-24a8 8 0 0 1 11.32-11.32L112 148.69l50.34-50.35a8 8 0 0 1 11.32 11.32"
      />
    </svg>
    <h1
      class="text-4xl font-bold uppercase text-indigo-600 transition duration-500"
    >
      Thank You
    </h1>
    <h1
      class="text-4xl font-bold uppercase text-indigo-600 transition duration-500"
    >
      Order Successfully Placed
    </h1>
    <h2 class="text-xl text-gray-700 transition duration-500">
      We will keep you posted about the status of the order via mail
    </h2>
    <p
      class="text-xl font-bold uppercase bg-black text-white p-3 m-3 rounded-lg transition duration-500"
    >
      Estimated delivery Date 12 Jan 2023 | Payment Method CASH ON DELIVERY
    </p>

    <div class="flex justify-center">
      <a
        routerLink="/"
        title="Quicktoolz On Facebook"
        class="btncolor tracking-wide font-bold rounded m-3 hover:text-white rounded-full hover:bg-purple-600 shadow-md py-2 px-6 inline-flex items-center transition duration-500"
      >
        <span class="mx-auto">Continue shopping</span>
      </a>
    </div>
  </div>
</div>
